export const defaultMatchTypes = [
  "League",
  "Playoff",
  "Tournament",
  "Event",
  "Training",
];

export const matchTypesWithThumbnailLabel = ["Playoff", "Tournament"];
